<template>
    <b-btn variant="sheet" @click="onClick" :class="[variant ? 'text-' + variant : '', linkClass]" :to="to" :href="href" :target="target">
        <i v-if="icon" class="action-sheet-icon fa-fw" :class="icon"></i>
        <slot></slot>
    </b-btn>
</template>

<script>

export default {
    name: `e-action-sheet-item`,
    props: {
        icon: { type: String },
        variant: { type: String },
        linkClass: { type: [String, Array, Object] },
        to: { type: String },
        href: { type: String },
        target: { type: String }
    },
    methods: {
        onClick($event) {
            if (!this.to || !this.href) {
                this.$emit(`click`, $event);
            }
        }
    }
}
</script>

<style lang="scss">
.btn.btn-sheet {
    display: block;
    background: white;
    border-radius: 15px;
    padding: 15px;
    text-align: center;
    font-size: 12pt;
    width: 100%;
    border: none;
    box-shadow: none;

    &:not(.not-interactive) {
        &:hover {
            background: #eee;
        }

        &:active {
            background: #ddd;
        }
    }

    & + .btn {
       border-block-start: 1px solid rgba(black, 0.15) !important;
    }

    .action-sheet-icon {
        margin-inline-end: 0.5rem;
    }
}
</style>
